<template>
  <div class="home">
    <Header />
    <Hall v-if="!session.NoSeats" />
    <SelectPlaceWithoutHall v-else />
    <Footer />

    {{ log(session) }}
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import Hall from '../components/Hall.vue';
import SelectPlaceWithoutHall from '../components/SelectPlaceWithoutHall.vue';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default {
  name: 'home',
  components: {
    Hall,
    SelectPlaceWithoutHall,
    Header,
    Footer,
  },
  computed: {
    ...mapState(['session']),
  },
  methods: {
    log: m => console.log(m),
  },
};
</script>

<style lang="scss">
.home {
  height: 100vh;
}
</style>
